// Site Configurations for Westin Store
// -- These values are unique for each site and rarely need to be changed after initial setup
// -- They are passed to the coreContext in _app.tsx and can be accessed in hah-fe-core via the useContext hook

import type { RumConfig } from '@Hotels-at-Home/hah-fe-core/dist/hooks/useRumScript';

export const csrEmail = 'customer.service@westinstore.com';
export const siteName = 'Westin Store';
export const parentHotelCompany = 'Marriott';
export const hotelBrandName = 'Westin Hotels & Resorts';
export const catalogId = 'HB';
export const region = 'EU';
export const companyTelephone = '+33 1 41 51 51 55';
export const employeePromoTag = 'employeesite';

export const scandiWebMenuId = 'hbeu';

export const LOGO_IMAGE = { src: '/images/misc/westin-logo.svg', alt: 'Westin Store' };

export const promo = {
  displaySaleFlag: false,
  // Promo discount (in percent)
  discount: '-35%',
  // products "SKUs" excluded from sale (the SaleFlag will be not displayed for this items)
  productsSaleExcludeList: [] as string[],
  // categories "IDs" excluded from sale (the SaleFlag will be not displayed for this items)
  categoriesSaleExludeList: [] as number[],
};

// Search Settings
export const SEARCH_CHARACTERS_MIN_LENGTH = 3;

// Product/Category Page Settings
// - imageWidth/imageHeight set the size of the <img /> on cat/prod pages to prevent layout shift
export const product = {
  imageWidth: 1145,
  imageHeight: 800,
  counterButtons: true,
  ymalQty: 3,
  almaWidget: true,
};

export const category = {
  imageEagerLoadingAmount: 3,
};

// Misc
export const firstVisitModal = {
  modalWidth: 659,
};

export const header = {
  shallowMobileMenu: true,
};

export const cart = {
  counterButtons: true,
  drawerContinueShopping: false,
  useCartDrawer: true,
  staticQuantity: true,
  ymalName: 'HBEU - Cart',
  disableCartYmals: true,
  drawerTotalInBUtton: false,
};

export const checkout = {
  radioButtons: true,
  placeholderLabels: true,
  paymentMethodProceedButton: true,
};

// Adobe Launch Settings
// - Remove these lines completely if this is not a Marriott site
export const enableBonvoyNumber = true;
export const enableMarriottAdobeLaunch = true;
export const enableBonvoyLoyaltyProgramme = true;
export const account = {
  disableAccountDrawer: false,
  enableWelcomeMessage: true,
};
export const marriottAdobeLaunchBrandCode = 'WI';
export const marriottAdobeLaunchBrandName = 'Westin Hotels & Resorts';

// Google Tag Manager & Analytics Settings
export const enableGoogleTagManager = true;
export const googleTagManagerId = 'GTM-NF96D36';
export const productNameFilters = {
  replacements: [{ target: 'Shop Westin Store', replacement: 'Shop' }],
  splits: [{ split: ' - ', keepIndex: 0 }],
};

// CloudWatch RUM (Real User Monitoring)
// Loaded by useRumScript hook in App.tsx, gated on ConsentMode.analytics
// (OneTrust via Adobe Launch).
// AppMonitor ID and identity pool ID are public identifiers (they ship in the client
// bundle); see cloudwatch-rum-gdpr-investigation.md in hah-docs for rationale.
export const cloudWatchRum: RumConfig = {
  applicationId: '2676e49c-2919-47ba-b15e-e55431905232',
  region: 'eu-central-1',
  identityPoolId: 'eu-central-1:9a1b3829-11c8-4a06-b474-df9fd49dc0d1',
};

// Cookie Restorer for Safari ITP
export const cookieRestorerEnabled = true;
export const cookieRestorerOptions = { options: { interval: 5000 } };

// Meta Tags
export const googleSiteVerification = 'l0jCMUokEPN_Sbzt6XQuuf-siPaJBFHnve09_evsMaI';
export const defaultOgImage = '/images/homePage/the-westin-heavenly-bed-sleep-well.webp';

export const INTL_SITES = [
  {
    region: 'NA',
    links: [
      { value: 'U.S.A.', url: 'https://shop.marriott.com/brands/westin.html' },
      { value: 'Canada', url: 'https://canada.westinstore.com/?referrer=eu' },
    ],
  },
  {
    region: 'APAC',
    links: [
      {
        value: 'English',
        url: 'https://www.westinstore.cn/en/?___store=westinstore_en&referrer=eu',
      },
      {
        value: '简体中文',
        url: 'https://www.westinstore.cn/zh-CN/?___store=westinstore_zh&referrer=eu',
      },
    ],
  },
];

export const zendeskKey = 'a2ab82c1-255b-49f3-b060-c521e43d43d7';
